import HttpService from './HttpService';
import type { ResponseType } from 'axios';
import {
  pathReportingAllClientsExcel,
  pathReportingAllAgentsExcel,
  pathReportingAllMattersExcel,
  pathReportingAllTasksExcel,
  pathReportingMyMattersExcel,
  pathReportingMyTasksExcel,
  pathReportingTasksByMatterExcel,
} from '@frontend/__settings__/septSoftwarePaths';
import {
  ExcelReportRequest,
  ExcelReportResponse,
} from '@frontend/Models/Reporting/ReportingRequestResponseModels';

const http = new HttpService();
const excelConfig = { responseType: 'blob' as ResponseType };
class ReportingService {
  static async getAllClientsExcel(req: ExcelReportRequest): Promise<ExcelReportResponse> {
    // the config should allow for response type of blob

    return http.post<ExcelReportResponse>(pathReportingAllClientsExcel, req, excelConfig);
  }
  static async getAllAgentsExcel(req: ExcelReportRequest): Promise<ExcelReportResponse> {
    return http.post<ExcelReportResponse>(pathReportingAllAgentsExcel, req, excelConfig);
  }
  static async getMattersByEmployeeIdExcel(employeeId: string, req: ExcelReportRequest): Promise<ExcelReportResponse> {
    return http.post<ExcelReportResponse>(pathReportingMyMattersExcel(employeeId), req, excelConfig);
  }
  static async getAllMattersExcel(req: ExcelReportRequest): Promise<ExcelReportResponse> {
    return http.post<ExcelReportResponse>(pathReportingAllMattersExcel, req, excelConfig);
  }
  static async getAllTasksExcel(req: ExcelReportRequest): Promise<ExcelReportResponse> {
    return http.post<ExcelReportResponse>(pathReportingAllTasksExcel, req, excelConfig);
  }
  static async getTasksByEmployeeIdExcel(employeeId: string, req: ExcelReportRequest): Promise<ExcelReportResponse> {
    return http.post<ExcelReportResponse>(pathReportingMyTasksExcel(employeeId), req, excelConfig);
  }
  static async getTasksByMatterExcel(matterId: string, req: ExcelReportRequest): Promise<ExcelReportResponse> {
    return http.post<ExcelReportResponse>(pathReportingTasksByMatterExcel(matterId), req, excelConfig);
  }
}

export default ReportingService;
